import { render, staticRenderFns } from "./Queen.vue?vue&type=template&id=dee0f7fa&scoped=true&"
import script from "./Queen.vue?vue&type=script&lang=js&"
export * from "./Queen.vue?vue&type=script&lang=js&"
import style0 from "./Queen.vue?vue&type=style&index=0&id=dee0f7fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee0f7fa",
  null
  
)

export default component.exports